export default { sha: '1e2a68aace632ad0640d3114d2f3fdf9169253f6', buildNumber: 'undefined' }
